import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  return {
    container: {
      margin: "1.5rem",
    },
    userProfileContainer: {
      padding: "2rem",
    },
    userProfileContentContainer: {
      display: "flex",
      backgroundColor: "#ffffff",
      borderRadius: 16,
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
      border: "1px solid #eef0f3",
      padding: "2rem",
    },
    userProfileImageError: {
      borderRadius: "100%",
      height: "120px",
      objectFit: "cover",
      width: "120px",
      border: "3px solid #eef0f3",
      textAlign: "center",
    },
    userProfileImage: {
      marginTop: "0.2rem",
      borderRadius: "100%",
      height: "120px",
      width: "120px",
      objectFit: "cover",
      border: "3px solid #eef0f3",
    },
    userProfileTextContainer: {
      marginTop: "0.2rem",
      marginLeft: "2.5rem",
    },
    userProfileName: {
      fontSize: "1.5rem",
      fontWeight: 700,
      color: "#1f2937",
      marginBottom: "0.35rem",
    },
    profileText: {
      marginTop: "0.4rem",
      fontSize: "0.95rem",
      color: "#374151",
    },
    userProfileEmail: {
      marginTop: "0.2rem",
      fontSize: "0.9rem",
      color: "#6b7280",
    },
    userProfilePhone: {
      fontSize: "0.9rem",
      marginTop: "0.25rem",
      color: "#6b7280",
    },
    userProfileRoleContainer: {
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      backgroundColor: "rgba(17, 98, 254, 0.1)",
      borderRadius: 999,
      padding: "4px 12px",
      margin: "0.6rem 0",
    },
    userProfileRoleIcon: {
      fontSize: "0.9rem",
      color: "#1162FE",
    },
    userProfileRole: {
      fontSize: "0.85rem",
      fontWeight: 600,
      color: "#1162FE",
    },
    userProfileButton: {
      marginTop: "0.4rem",
      textTransform: "none",
      fontWeight: 600,
      borderRadius: 10,
      width: "210px",
      justifyContent: "flex-start",
    },
    userProfileActionButtonContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "16px",
    },
    profileContainer: {
      borderRadius: 16,
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
      border: "1px solid #eef0f3",
    },
    profileContentContainer: {
      padding: "1.5rem",
    },
  };
});
